<div [attr.data-client]="IcName" class="space">
    <div class="logobar">
        <div>
            <div>
                <a routerLink="/ssi/home">
                    <div class="logo">
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-24">
                <h2>Drug Pricing Tool</h2>
            </div>
        </div>
        <div class="row" *ngIf="hasError">
            <div class="col-24">
                <div class="alert danger">
                    <p><em>Error Message:</em></p>
                    <div *ngFor="let error of ErrorMessages">
                        <p [innerHtml]="error"></p>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-10">
                <label >State</label>
                <ValidatedDropDown class="wide" style="padding-left:27px;"
                                   [options]="this.states"
                                   (onValueChange)="this.selectedState=$event">
                </ValidatedDropDown>
            </div>
        </div><br />
        <div class="row">
            <div class="col-10">

                <ValidatedTextField [label]="'ZIP code'" style="height: 39px;width: 164px;"
                                    [text]="this.zipCode"
                                    (onValueChange)="this.zipCode = $event" [maxlength]="'5'"
                                    [validators]="[notBlankValidator]">
                </ValidatedTextField>
                
            </div>
        </div>
        <div class="row">
            <div class="col-10 space">
                <span>Example 12345</span>
            </div>
          
        </div>
        <br />
        <div class="row">
            <div class="col-24">
                <input type="image" class="button secondary" [src]="LOGO" (click)="navigateToDrugPricingTool()"/>
                <!--<button class="button secondary cntButton" (click)="navigateToDrugPricingTool()">Continue</button>-->
            </div>
        </div>
    </div>
</div>